import { render, staticRenderFns } from "./OrderItemLinkEditForm.vue?vue&type=template&id=5a6ea710"
import script from "./OrderItemLinkEditForm.vue?vue&type=script&lang=js"
export * from "./OrderItemLinkEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports